<template>
    <div>
        <BestProductsTable
            v-if="!metricsIsEmpty"
            :statistics="statistics.MC[$page.props.store.id]"
            @reloadStats="fetchData">
        </BestProductsTable>
        <p v-else class="text-center text-xl mt-4">{{ __('statistics.impressions_empty_for_filters') }}</p>
    </div>
</template>

<script>
import StatisticsLayout from '@layouts/Statistics/StatisticsLayout.vue';
import BestProductsTable from '@components/Stats/Components/BestProductsTable.vue';

export default {
    components: {BestProductsTable},
    layout: StatisticsLayout,

    props: {
        statistics: Object,
        initFilters: Object,
    },

    methods: {
        fetchData() {
            this.$inertia.reload({only: ['initFilters', 'statistics']});
        },
    },

    computed: {
        metricsIsEmpty() {
            return this.statistics.MC[this.$page.props.store.id].data.length === 0;
        },
    },
};
</script>
